import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=035f4c8f&scoped=true&"
import script from "./ProfileDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=035f4c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f4c8f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileDetailDonation: require('/home/bitrix/frontend/components/profile/ProfileDetailDonation.vue').default,Achievement: require('/home/bitrix/frontend/components/profile/Achievement.vue').default,MasterpieceRecieved: require('/home/bitrix/frontend/components/other/MasterpieceRecieved.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default,PatronImage: require('/home/bitrix/frontend/components/forms/PatronImage.vue').default,BecamePatron: require('/home/bitrix/frontend/components/forms/BecamePatron.vue').default,Patron: require('/home/bitrix/frontend/components/forms/Patron.vue').default,MtModalFull: require('/home/bitrix/frontend/components/Modal/MtModalFull.vue').default})
